import React, { useMemo } from 'react'
import { statusAzmanotList } from '../../../../../generic/artcoded/statusAzmanot'
import { FilterMenuButton } from '../../../../../generic/ui/FilterMenuButton'

interface Props {
    value: number | null
    onChange: (id: number | null) => void
}

type StatusItem = (typeof statusAzmanotList)[number]

const StatusFilterButton: React.FC<Props> = ({ value, onChange }) => {
    const items = useMemo(() => statusAzmanotList.filter((s) => s.id !== -1), [])
    const selected = items.find((s) => s.id === value) ?? null

    return (
        <FilterMenuButton<StatusItem>
            items={items}
            value={selected}
            onChange={(item) => onChange(item ? item.id : null)}
            getKey={(s) => s.id}
            getLabel={(s) => s.Desc}
            getColor={(s) => s.color}
            ariaLabel='סינון לפי סטטוס'
        />
    )
}

export default StatusFilterButton
